import Card from '~/components/Card';
import {
  ExchangeOptionsProvider,
  useExchangeSelection,
} from './exchangeOptions';
import ProductSelectionGrid from './ProductSelectionGrid';
import ProductVariantSelector from './ProductVariantSelector';

function ProductExchangeCard() {
  const [{ selectedProduct }] = useExchangeSelection();
  return (
    <Card headline={!selectedProduct ? 'The product you will get' : ''}>
      <ProductVariantSelector />
      <ProductSelectionGrid />
    </Card>
  );
}

export default function ProductExchange() {
  return (
    <ExchangeOptionsProvider>
      <ProductExchangeCard />
    </ExchangeOptionsProvider>
  );
}
